// Styles
import { getClassNames, getStyles } from "./WeekdayPicker.styles";
// Utilities
import React, { useMemo } from "react";
import { css } from "@fluentui/utilities/lib/css";
import map from "lodash/map";
import moment from "moment";
import { DayOfWeek } from "@ms/uno-constants/lib/local/DateConstants";
import { getDaysOfWeekByStartDay, getMomentDayIndexFromDayOfWeek } from "@ms/uno-utilities/lib/local/DateUtilities";
import { Strings } from "@ms/uno-resources/lib/local/CultureUtilities";
import { useTheme } from "@fluentui/react";
/**
 * Weekday picker component
 */ export function WeekdayPicker({ selectedDaysOfWeek, styles, onClickWeekday }) {
    const weekdayPickerClassNames = getClassNames(getStyles(useTheme(), styles));
    const daysOfWeek = getDaysOfWeekByStartDay(moment.localeData().firstDayOfWeek());
    const dayOfWeekButtons = useMemo(()=>map(daysOfWeek, (day)=>{
            const isSelected = selectedDaysOfWeek.indexOf(day) > -1;
            const buttonClassName = css(weekdayPickerClassNames.weekdayButton, {
                selected: isSelected
            });
            return /*#__PURE__*/ React.createElement("button", {
                className: buttonClassName,
                onClick: ()=>onClickWeekday(day, !isSelected),
                "aria-label": moment.weekdays(getMomentDayIndexFromDayOfWeek(day)),
                key: getMomentDayIndexFromDayOfWeek(day),
                role: "checkbox",
                "aria-checked": isSelected,
                type: "button"
            }, /*#__PURE__*/ React.createElement("span", null, getWeekdayButtonString(day)));
        }), [
        onClickWeekday,
        selectedDaysOfWeek,
        daysOfWeek,
        weekdayPickerClassNames
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: weekdayPickerClassNames.root,
        "aria-label": Strings.WeekdayPicker_WeekdayPickerAriaLabel
    }, dayOfWeekButtons);
}
/**
 * Get the localized string for the weekday abbreviations
 * @param day The day to get the abbreviated string for
 */ function getWeekdayButtonString(day) {
    switch(day){
        case DayOfWeek.Sunday:
            return Strings.WeekdayPicker_SundayAbbreviation;
        case DayOfWeek.Monday:
            return Strings.WeekdayPicker_MondayAbbreviation;
        case DayOfWeek.Tuesday:
            return Strings.WeekdayPicker_TuesdayAbbreviation;
        case DayOfWeek.Wednesday:
            return Strings.WeekdayPicker_WednesdayAbbreviation;
        case DayOfWeek.Thursday:
            return Strings.WeekdayPicker_ThursdayAbbreviation;
        case DayOfWeek.Friday:
            return Strings.WeekdayPicker_FridayAbbreviation;
        case DayOfWeek.Saturday:
        default:
            return Strings.WeekdayPicker_SaturdayAbbreviation;
    }
}
